<template>
  <div class="hospitalAgain">
    <div class="top">
      <hospital-info />
      <span><router-link to="/courier/medical">重新选择</router-link></span>
    </div>
    <div class="middle">
      <div class="top" v-for="(item, index) in doctorInfo" :key="index">
        <doctor-info :doctorInfo="item" />
        <span v-if="info.hospitalDto"><router-link :to="{name: 'Doctor', query: {hospitalId: info.hospitalDto.id, departmentIdA: info.doctorDtos[0].departmentIdA, departmentIdB: info.doctorDtos[0].departmentIdB}}">重新选择</router-link></span>
      </div>
      <p class="text">如果您指定的医生不出诊或无号源,是否同意就诊同科室的其他医生？</p>
      <div class="isAgree">
        <button :class="info.isAgree == 0 ? 'agree' : 'noAgree'" @click="changeAgree(0)">同意</button>
        <button :class="info.isAgree == 1 ? 'agree' : 'noAgree'" @click="changeAgree(1)">不同意</button>
      </div>
    </div>
    <patient-info :patientInfo="patientInfo" @info="childInfo" />
    <div class="raise">
      <raise-price />
    </div>
    <price-explain />
    <button class="pay" @click="pay">支付</button>
    <pay-way v-if="isShowPay" @close="showPay" />
  </div>
</template>

<script>
var _this
import HospitalInfo from '../../../components/Hospital/HospitalInfo'
import DoctorInfo from '../../../components/Hospital/DoctorInfo'
import PatientInfo from '../../../components/Hospital/PatientInfo'
import RaisePrice from '../../../components/Courier/RaisePrice'
import PriceExplain from '../../../components/Courier/PriceExplain'
import PayWay from '../../../components/Pay/PayWay'
import {mobiles, idCard} from '../../../utils/phone'
import {reqDoctorOrderDetail, reqOrderDoctor} from '../../../api'
import {mapState} from 'vuex'
export default {
  data() {
    return {
      info: {},
      patientInfo: {}, // 个人信息
      isShowPay: false // 显示支付宝
    }
  },
  created() {
    _this=this
    this.info.doctorId = this.doctorInfo.id
    const {id} = this.$route.query
    reqDoctorOrderDetail(id).then(res => {
      console.log(res)
      if(res.code === 200) {
        this.info = res.data.bussData
        this.patientInfo = {name: this.info.name, sex: this.info.sex == '男' ? 0 : 1, phone: this.info.phone, idCard:this.info.idCard, barCode: this.info.barCode, addRemark: this.info.addRemark, serviceDate:this.info.serviceDate, paytype: this.info.paytype }
        this.$store.dispatch('getFee', {serviceFee: this.info.serverFee, premiumFee: this.info.premiumFee})
        this.$store.dispatch('getAddFee', this.info.addFee)
        this.$store.dispatch('getDoctorInfo', res.data.bussData.doctorDtos)
        this.$store.dispatch('getHospitalInfo', res.data.bussData.hospitalDto)
      }
    })
  },
  methods: {
    // 点击是否同意
    changeAgree(i) {
      this.info.isAgree = i
      this.$forceUpdate(); // $forceUpdate可以迫使 Vue 实例重新渲染。它仅仅影响实例本身和插入插槽内容的子组件，而不是所有子组件。
    },
    // 显示支付方式
    showPay () {
      this.isShowPay = !this.isShowPay
    },
    // 接收孩子的信息
    childInfo(info) {
      this.info = Object.assign(info, this.info)
    },
    // 支付
    pay() {
      if(!this.info.visitDate) {
        this.$message({
          message: '就诊时间不能为空',
          type: 'error'
        })
      } else if(!this.info.name) {
        this.$message({
          message: '就诊人不能为空',
          type: 'error'
        })
      } else if(!this.info.phone) {
        this.$message({
          message: '就诊人手机号不能为空',
          type: 'error'
        })
      } else if(!mobiles(this.info.phone)) {
        this.$message({
          message: '就诊人手机号不正确',
          type: 'error'
        })
      } else if(!this.info.idCard) {
        this.$message({
          message: '就诊人身份证号不能为空',
          type: 'error'
        })
      } else if(!idCard(this.info.idCard)) {
        this.$message({
          message: '就诊人身份证号不正确',
          type: 'error'
        })
      } else if(!this.info.serviceDate) {
        this.$message({
          message: '服务时间不能为空',
          type: 'error'
        })
      }else if(this.info.paytype === '') {
        this.$message({
          message: '请选择付款方式',
          type: 'error'
        })
      } else {
        const {doctorId, doctor, department, hospital, patientid, name, sex, phone, idCard, addRemark, accountInfo, serviceDate, paytype, visitDate, isAgree} = this.info
        let body = {}
        console.log(patientid)
        console.log(this.doctorInfo)
        if(patientid) {
          body = {
            doctorId: this.doctorInfo[0].id, // 医生id
            doctor: this.doctorInfo[0].name, // 医生姓名
            department: this.doctorInfo[0].departmentName, // 科室名称
            hospital: this.hospitalInfo.name, // 医院名称
            hospitalid: this.hospitalInfo.id,
            origin :1,
            patientid,
            addRemark,
            accountInfo,
            serviceDate,
            paytype,
            visitDate,
            isAgree,
            addFee: this.addFee,
            couponsubid: this.amount.couponId
          }
        } else {
          body = {
            doctorId: _this.doctorInfo[0].id,
            doctor: _this.doctorInfo[0].name,
            department: _this.doctorInfo[0].departmentName,
            hospital: _this.hospitalInfo.name,
            hospitalid: _this.hospitalInfo.id,
            name,
            origin :1,
            sex: sex == '男' ? 0 : 1,
            phone,
            idCard,
            addRemark,
            accountInfo,
            serviceDate,
            paytype,
            visitDate,
            isAgree,
            addFee: this.addFee,
            couponsubid: this.amount.couponId
          }
        }
        reqOrderDoctor(body).then(res => {
          console.log(res)
          if(res.code === 200) {
            this.showPay()
            this.$store.dispatch('getOrderInfo', res.data.bussData)
          }
        })
      }
    }
  },
  computed: {
    ...mapState(['doctorInfo', 'hospitalInfo', 'addFee', 'amount'])
  },
  components: {
    HospitalInfo,
    DoctorInfo,
    PatientInfo,
    RaisePrice,
    PriceExplain,
    PayWay
  }
}
</script>

<style scoped lang="less" type="text/less">
  .hospitalAgain{
    padding-top:60px;
    .top{
      display: flex;
      justify-content: space-between;
      margin-bottom: 31px;
      span{
        display: inline-block;
        width: 100px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
        border:1px solid #e1e1e1;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .middle{
      .top{
        margin-bottom: 20px;
      }
      .text{
        margin:20px 0;
      }
      .isAgree{
        button{
          width: 80px;
          height: 39px;
          margin-bottom: 40px;
          border:none;
          border-radius: 20px;
          box-sizing: border-box;
          margin-right: 20px;
          &.agree{
            background: #2FA1DE;
            color:#fff;
          }
          &.noAgree{
            background: #fff;
            color:#333;
            border:1px solid #e1e1e1;
          }
        }
      }
    }
    .raise{
      width: 534px;
      margin: 40px 0;
    }
    .pay{
      display: block;
      width: 332px;
      height: 48px;
      margin:30px 0 0 136px;
      background: #61aee6;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      border:none;
      box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
      border-radius:24px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/HospitalAgain.vue